(() => {
  const storageKey = 'homebodiiFreeShippingProgressEnabled';
  const activeClass = 'free-shipping-progress-ab-enabled';
  const enableAttempts = 3;
  const enableDelay = 500;
  let observer;
  let enableTimer;

  const getStoredOverride = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const setStoredOverride = (enabled) => {
    try {
      if (enabled) {
        window.localStorage.setItem(storageKey, 'true');
      } else {
        window.localStorage.removeItem(storageKey);
      }
    } catch (error) {
      // Storage can be unavailable in privacy modes; the in-memory class still works.
    }
  };

  const isForcedOn = () =>
    document.documentElement.classList.contains(activeClass) ||
    getStoredOverride();

  const setVisibleState = () => {
    document.documentElement.classList.toggle(activeClass, isForcedOn());
  };

  const updateBar = (bar) => {
    const enabledByTheme = bar.dataset.freeShippingEnabled === 'true';
    bar.classList.toggle('free-shipping-bar--disabled', !enabledByTheme && !isForcedOn());

    if (bar.dataset.freeShippingProgress !== '1') {
      bar.dataset.freeShippingState = 'pending';
      return;
    }

    if (bar.dataset.freeShippingFinalized === 'true') return;

    bar.dataset.freeShippingState = 'unlocked';
    window.setTimeout(() => {
      if (bar.isConnected && bar.dataset.freeShippingProgress === '1') {
        bar.dataset.freeShippingState = 'got';
        bar.dataset.freeShippingFinalized = 'true';
      }
    }, 2000);
  };

  const refresh = () => {
    setVisibleState();
    document.querySelectorAll('.free-shipping-progress-bar').forEach(updateBar);
  };

  const cancelEnableChecks = () => {
    clearTimeout(enableTimer);
    enableTimer = null;
  };

  const applyEnabledState = (options = {}) => {
    if (options.persist !== false) setStoredOverride(true);
    document.documentElement.classList.add(activeClass);
    refresh();
  };

  const scheduleEnableChecks = (options = {}) => {
    let attemptsRemaining = enableAttempts;

    cancelEnableChecks();

    const run = () => {
      applyEnabledState(options);
      attemptsRemaining -= 1;

      if (attemptsRemaining > 0) {
        enableTimer = window.setTimeout(run, enableDelay);
      } else {
        enableTimer = null;
      }
    };

    run();
  };

  const api = window.HomebodiiFreeShippingProgress || {};
  api.enable = (options = {}) => {
    scheduleEnableChecks(options);
  };
  api.disable = () => {
    cancelEnableChecks();
    setStoredOverride(false);
    document.documentElement.classList.remove(activeClass);
    refresh();
  };
  api.refresh = refresh;
  window.HomebodiiFreeShippingProgress = api;

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('on:cart:after-merge', refresh);
  refresh();

  if (!observer) {
    observer = new MutationObserver(refresh);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
